import { Icon, type Props } from "./DeleteIcon.Parts";

export const DeleteIcon = (props: Props) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    {...props}
  >
    <path
      d="M15.3267 5.27693C15.5341 5.27693 15.7019 5.10918 15.7019 4.90177V3.5083C15.7019 3.30089 15.5341 3.13314 15.3267 3.13314H0.674969C0.467557 3.13314 0.299805 3.30089 0.299805 3.5083V4.90177C0.299805 5.10918 0.467557 5.27693 0.674969 5.27693H1.39528V17.8562V20H14.6064V17.8562V5.27693H15.3267ZM5.08422 17.8562H3.53854V5.27693H5.08422V17.8562ZM8.77369 17.8562H7.22801V5.27693H8.77369V17.8562ZM12.4632 17.8562H10.9175V5.27693H12.4632V17.8562Z"
      fill="currentColor"
    />
    <path
      d="M10.5474 1.76863L10.5474 0.375164C10.5474 0.167967 10.3794 -7.34206e-09 10.1722 -1.6399e-08L5.80368 -2.07353e-07C5.59648 -2.1641e-07 5.42852 0.167966 5.42852 0.375164L5.42852 1.76863C5.42852 1.97583 5.59648 2.14379 5.80368 2.14379L10.1722 2.14379C10.3794 2.1438 10.5474 1.97583 10.5474 1.76863Z"
      fill="currentColor"
    />
  </Icon>
);
